/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum CriteriaType {
    AND = 'AND',
    OR = 'OR',
}
